import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Table,
  Input,
  Select,
  Form,
  Tooltip,
  Col,
  Spin,
  Radio,
  Modal,
  Row,
  Button,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import SiteSelectionModal from "./../../feature/PR/SiteSelectionModal";
import { Collapse } from "antd";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";
import NewAddPRMaterial from "../NewPrMaterial/NewAddPRMaterial";
import { InfoCircleFilled } from "@ant-design/icons";

const { Panel } = Collapse;

const NewAddPR = (selectedCategoryId) => {
  const [siteName, setSiteName] = useState([]);
  const navigate = useNavigate();
  const { Option } = Select;
  const [pincodeList, setPincodeList] = useState([]);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [view, setView] = useState("City Wise");
  const [userSelectedSiteList, setUserSelectedSiteList] = useState([]);
  const [siteModal, setSiteModal] = useState(false);
  const [reload, setReload] = useState(false);

  const { t } = useTranslation();
  const { id, prId } = useParams();
  const formRef = useRef();

  const [disabled, setDisabled] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [stateWBS, setStateWBS] = useState([]);

  const [state, setState] = useState([]);

  const [siteTotalQuantities, setSiteTotalQuantities] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [cityLength, setCityLength] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [apiLoading, setapiLoading] = useState(false);
  const [viewOption, setViewOption] = useState(false);
  const [prView, setPRView] = useState(null);

  const [overallTotal, setOverallTotal] = useState(0);

  const { state: details } = useLocation();

  const { categoryId, siteIds, selectedCategoryName } = details;

  const getSubCategory = async () => {
    setapiLoading(true);

    try {
      const form_data = new FormData();
      form_data.append("site_ids", siteIds.join(","));
      let apiResponse = await postRequest(
        `company-material-code/${categoryId}/get-pr-material-by-city/`,
        form_data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (apiResponse.data.success) {
        const filteredData = {
          ...apiResponse.data.data,
          city_wise_pr: apiResponse.data.data.city_wise_pr.filter((city) =>
            city.site_wise_details.some(
              (site) => site.material_wise_details?.length > 0
            )
          ),
        };
        setState(filteredData);
        setPRView(apiResponse?.data?.data?.pr_type);
        const prType = apiResponse.data.data.pr_type || "City Wise";
        setView(prType);
        formRef.current.setFieldsValue({
          pr_view: prType,
        });
      }

      if (apiResponse.data.data) {
        const purchaseRequisitionDetails = apiResponse.data.data.map((item) => {
          // ff
        });
        setState((prevState) => ({
          ...prevState,
          purchase_requisition_details: purchaseRequisitionDetails,
        }));
        const uniqueSubCategories = Array.from(
          new Set(apiResponse.data.data.map((item) => item.sub_category))
        );

        setSubCategoryList(uniqueSubCategories);
        setSubCategoryData(apiResponse.data.data);
        setapiLoading(false);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };

  useEffect(() => {
    getSubCategory();
    getCurrency();
    getUnitOfMeasurement();
    if (siteName.length === 0) {
      getSiteName();
    }
    if (siteIds && siteIds.length > 0) {
      setUserSelectedSiteList(siteIds);
    }
  }, [id, prId]);

  const filterParentDataBySites = (parentData, comparisonData) => {
    if (
      !parentData ||
      !comparisonData ||
      !Array.isArray(parentData) ||
      !Array.isArray(comparisonData)
    ) {
      return [];
    }

    const siteIds = new Set(comparisonData.map((site) => site.id));

    return parentData
      .map((city) => {
        if (!city || !city.site_wise_details) return null;
        const filteredSites = city.site_wise_details.filter((site) =>
          siteIds.has(site.site_id)
        );
        return filteredSites.length > 0
          ? { ...city, site_wise_details: filteredSites }
          : null;
      })
      .filter((city) => city !== null);
  };

  const updateFilteredData = () => {
    if (!state.city_wise_pr || !userSelectedSiteList) return;

    const filteredData = filterParentDataBySites(
      state.city_wise_pr,
      userSelectedSiteList
    );

    setState((prevState) => {
      if (
        JSON.stringify(prevState.city_wise_pr) !== JSON.stringify(filteredData)
      ) {
        return { ...prevState, city_wise_pr: filteredData };
      }
      return prevState;
    });
  };

  useEffect(() => {
    if (userSelectedSiteList && userSelectedSiteList.length > 0) {
      updateFilteredData();
    }
  }, [userSelectedSiteList]);

  let updateTableData = [];

  let updateWbsData = [];
  let updateTableDataOptionChange = [];

  updateTableDataOptionChange = (state) => {
    setapiLoading(true);
    const tableData = [];
    const length = state?.city_wise_pr?.length;
    setCityLength(length);

    state?.city_wise_pr?.forEach((city, cityIndex) => {
      const cityHasMaterials = city.site_wise_details.some(
        (site) => site.material_wise_details?.length > 0
      );
      if (!cityHasMaterials) return;

      let cityTotalQuantity = 0;
      let cityTotalQuantityForKG = 0;
      let cityTotalAmountForKG = 0;
      let cityTotal = 0;

      city.site_wise_details.forEach((site, siteIndex) => {
        // Skip site if it has no materials
        if (!site.material_wise_details?.length) return;

        site.material_wise_details?.forEach((material) => {
          material.material_type_quantity = 0;
          material.material_total_quantity_by_kg = 0;
          material.material_remark = "";
        });

        site.site_total_quantity = 0;
        site.site_total_quantity_kg = 0;
        site.site_total_amount_kg = 0;

        tableData.push({
          key: `${cityIndex}-${siteIndex}`,
          srNo:
            length > 1
              ? siteIndex === 0
                ? cityIndex + 1
                : null
              : siteIndex + 1,
          cityName: siteIndex === 0 ? city.city_name : null,
          cityRowSpan: siteIndex === 0 ? 2 : 0,
          siteName: site.site_name,
          siteLocations: site.material_wise_details?.map((material) => {
            return {
              availableBudget: material.available_budget || 0,
              estimatedPRValue: material.estimated_pr_value || 0,
              materialName: material.material_type_name,
              estimated_price: material.estimated_material_unit_price,
              remark: "",
              quantity: 0,
              uom: material.material_type_uom,
              material_type_uom_name: material.material_type_uom_name,
              subCategory: material.material_type_sub_category,
              estimatedPrice: 0,
            };
          }),
          totalAmount: <Input disabled value="₹ 0" className="site-subtotal" />,
        });

        tableData.push({
          key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
          siteName: `Sub Total for ${site.site_name} site`,
          siteName1: "Site Sub Total",
          siteLocations: [
            {
              totalQuantity: 0,
              totalQuantityByKG: 0,
              totalAmountByKG: 0,
              materialName: "",
              quantity: 0,
              subCategory: "",
            },
          ],
          totalAmount: <Input disabled value="₹ 0" className="site-subtotal" />,
          siteTotalQuantity: (
            <Input
              disabled
              value="0"
              className="site-total-quantity"
              readOnly
            />
          ),
        });

        if (length > 1 && siteIndex === city.site_wise_details.length - 1) {
          tableData.push({
            key: `${cityIndex}-${siteIndex}-CityTotal`,
            siteName: `City Total - ${city.city_name}`,
            siteName1: "City Total",
            siteLocations: [
              {
                materialName: "",
                cityTotal: 0,
                quantity: 0,
                cityQuantityForKG: 0,
                cityTotalAmountForKG: 0,
                subCategory: "",
              },
            ],
            totalAmount: (
              <Input disabled value="₹ 0" className="subtotal" readOnly />
            ),
            cityTotalQuantity: (
              <Input
                disabled
                value="0"
                className="city-total-quantity"
                readOnly
              />
            ),
          });
        }
      });

      city.city_total_quantity = 0;
    });

    // Only add grand total if there are valid entries in tableData
    if (tableData.length > 0) {
      tableData.push({
        key: `Total`,
        siteName: `Estimated Total Price`,
        siteName1: "Total",
        siteLocations: [
          {
            materialName: "",
            cityTotal: 0,
            quantity: 0,
            cityQuantityForKG: 0,
            cityTotalAmountForKG: 0,
            subCategory: "",
          },
        ],
        totalAmount: (
          <Input disabled value="₹ 0" className="subtotal" readOnly />
        ),
        totalQuantity: (
          <Input disabled value="0" className="city-total-quantity" readOnly />
        ),
      });
    }

    setTableData(tableData);
    setapiLoading(false);
  };
  if (prId === null || prId === undefined) {
    const updatedState = { ...state };
    updateTableData = (state) => {
      console.log("stffffate", state);

      setapiLoading(true);
      const tableData = [];
      const length = state?.city_wise_pr?.length;
      setCityLength(length);

      let totalCityOfAllSite = 0;
      state?.city_wise_pr?.forEach((city, cityIndex) => {
        const cityHasMaterials = city.site_wise_details.some(
          (site) => site.material_wise_details?.length > 0
        );
        if (!cityHasMaterials) return; // Skip this city

        const cityRowSpan = 2;

        let cityTotalQuantity = 0;
        let cityTotalQuantityForKG = 0;
        let cityTotalAmountForKG = 0;
        let cityTotal = 0;
        city.site_wise_details.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteTotalQuantityForKG = 0;
          let siteTotalAmountForKG = 0;
          let siteMaterialTotal = 0;
          let siteMaterialTotalkgg = 0;

          site.material_wise_details?.forEach((material) => {
            console.log("materialddd", material);

            // material.material_remark = null;
            siteTotalQuantity += material.material_type_quantity;
            siteMaterialTotal +=
              material.material_type_quantity *
              material.estimated_material_unit_price;

            if (
              material.material_type_name?.includes("Sand") &&
              material.material_type_uom_name === "Cum."
            ) {
              siteMaterialTotalkgg +=
                material.material_type_quantity *
                material.sand_conversion *
                1000 *
                material.estimated_material_unit_price;
            } else if (
              material.material_type_name?.includes("Sand") &&
              material.material_type_uom_name === "MT"
            ) {
              siteMaterialTotalkgg +=
                material.material_type_quantity *
                1000 *
                material.estimated_material_unit_price;
            } 
            
            else if (
              material.material_type_name?.includes("Aggregate") &&
              material.material_type_uom_name === "Cum."
            ) {
              console.log('mateddgggrial', material);
              
              siteMaterialTotalkgg +=
                material.material_type_quantity *
                material.aggregate_conversion *
                1000 *
                material.estimated_material_unit_price;
            } else if (
              material.material_type_name?.includes("Aggregate") &&
              material.material_type_uom_name === "MT"
            ) {
              siteMaterialTotalkgg +=
                material.material_type_quantity *
                1000 *
                material.estimated_material_unit_price;
            } 
            else if (
              material.material_type_name?.includes("Dust") &&
              material.material_type_uom_name === "Cum."
            ) {
              console.log('mateddgggrial', material);
              
              siteMaterialTotalkgg +=
                material.material_type_quantity *
                material.aggregate_conversion *
                1000 *
                material.estimated_material_unit_price;
            } else if (
              material.material_type_name?.includes("Dust") &&
              material.material_type_uom_name === "MT"
            ) {
              siteMaterialTotalkgg +=
                material.material_type_quantity *
                1000 *
                material.estimated_material_unit_price;
            }
            else if (material.material_type_uom_name === "MT") {
              siteMaterialTotalkgg +=
                material.material_type_quantity *
                1000 *
                material.estimated_material_unit_price;
            } else if (material.material_type_uom_name === "Bag") {
              siteMaterialTotalkgg +=
                material.material_type_quantity *
                50 *
                material.estimated_material_unit_price;
            } else {
              siteMaterialTotalkgg +=
                material.material_type_quantity *
                material.estimated_material_unit_price;
            }

            let quantityInKG = 0;
            if (
              material.material_type_name?.includes("Sand") &&
              material.material_type_uom_name === "Cum."
            ) {
              siteTotalQuantityForKG +=
                material.material_type_quantity *
                  material.sand_conversion *
                  1000 || 0;
              quantityInKG =
                material.material_type_quantity *
                  material.sand_conversion *
                  1000 || 0;
            } else if (
              material.material_type_name?.includes("Sand") &&
              material.material_type_uom_name === "MT"
            ) {
              siteTotalQuantityForKG +=
                material.material_type_quantity * 1000 || 0;
              quantityInKG = material.material_type_quantity * 1000 || 0;
            }

            else if (
              material.material_type_name?.includes("Aggregate" || "Dust") &&
              material.material_type_uom_name === "Cum."
            ) {
              siteTotalQuantityForKG +=
                material.material_type_quantity *
                  material.aggregate_conversion *
                  1000 || 0;
              quantityInKG =
                material.material_type_quantity *
                  material.aggregate_conversion *
                  1000 || 0;
            } else if (
              material.material_type_name?.includes("Aggregate" || "Dust") &&
              material.material_type_uom_name === "MT"
            ) {
              siteTotalQuantityForKG +=
                material.material_type_quantity * 1000 || 0;
              quantityInKG = material.material_type_quantity * 1000 || 0;
            }

            else if (
              material.material_type_name?.includes("Dust") &&
              material.material_type_uom_name === "Cum."
            ) {
              siteTotalQuantityForKG +=
                material.material_type_quantity *
                  material.aggregate_conversion *
                  1000 || 0;
              quantityInKG =
                material.material_type_quantity *
                  material.aggregate_conversion *
                  1000 || 0;
            } else if (
              material.material_type_name?.includes("Dust") &&
              material.material_type_uom_name === "MT"
            ) {
              siteTotalQuantityForKG +=
                material.material_type_quantity * 1000 || 0;
              quantityInKG = material.material_type_quantity * 1000 || 0;
            }

            
            else if (material.material_type_uom_name === "MT") {
              siteTotalQuantityForKG +=
                material.material_type_quantity * 1000 || 0;
              quantityInKG = material.material_type_quantity * 1000 || 0;
            } else if (material.material_type_uom_name === "Bag") {
              siteTotalQuantityForKG +=
                material.material_type_quantity * 50 || 0;
              quantityInKG = material.material_type_quantity * 50 || 0;
            } else {
              siteTotalQuantityForKG += material.material_type_quantity || 0;
              quantityInKG = material.material_type_quantity || 0;
            }

            const amountForMaterial =
              quantityInKG * material.estimated_material_unit_price;

            siteTotalAmountForKG += amountForMaterial;
          });
          site.site_total_quantity = siteTotalQuantity;
          site.site_total_quantity_kg = siteTotalQuantityForKG;
          site.site_total_amount_kg = siteTotalAmountForKG;

          setSiteTotalQuantities((prevQuantities) => [
            ...prevQuantities,
            siteTotalQuantity,
          ]);

          cityTotalQuantity += siteTotalQuantity;
          cityTotalQuantityForKG += siteTotalQuantityForKG;
          cityTotalAmountForKG += siteTotalAmountForKG;
          cityTotal += siteMaterialTotal;
          totalCityOfAllSite += siteMaterialTotalkgg;
          tableData.push({
            key: `${cityIndex}-${siteIndex}`,
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : null,
            cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
            siteName: site.site_name,
            siteLocations: site.material_wise_details?.map(
              (material, matIndex) => {
                console.log("matdderial", material);

                return {
                  availableBudget: material.available_budget || 0,
                  estimatedPRValue: material.estimated_pr_value || 0,
                  estimated_price: material.estimated_material_unit_price,
                  materialName: material.material_type_name,
                  remark: material.material_remark,
                  quantity: material.material_type_quantity,
                  uom: material.material_type_uom,
                  material_type_uom_name: material.material_type_uom_name,
                  subCategory: material.material_type_sub_category,
                  siteIndex,
                  matIndex,
                  cityId: city.city_id,
                  siteId: site.site_id,
                  estimatedPrice: material.estimated_material_unit_price,
                  sand_conversion: material.sand_conversion,
                  aggregate_conversion: material.aggregate_conversion,
                  category: state.category_tree_name
                };
              }
            ),
            totalAmount: <Input disabled className="site-subtotal" />,
          });
          tableData.push({
            key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
            siteName: `Sub Total for ${site.site_name} site`,
            siteName1: "Site Sub Total",
            siteLocations: [
              {
                totalQuantity: siteMaterialTotal,
                totalQuantityByKG: siteTotalQuantityForKG,
                totalAmountByKG: siteTotalAmountForKG,
                materialName: "",
                quantity: siteTotalQuantity,
                subCategory: "",
                siteIndex,
                matIndex: 0,
                cityId: city.city_id,
                siteId: site.site_id,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${siteTotalQuantity || 0}`}
                className="site-subtotal"
              />
            ),
            siteTotalQuantity: (
              <Input
                disabled
                value={siteTotalQuantity || 0}
                className="site-total-quantity"
                readOnly
              />
            ),
          });
          if (length > 1) {
            if (siteIndex === city.site_wise_details.length - 1) {
              tableData.push({
                key: `${cityIndex}-${siteIndex}-CityTotal`,
                siteName: `City Total - ${city.city_name} `,
                siteName1: "City Total",
                siteLocations: [
                  {
                    materialName: "",
                    cityTotal: cityTotal,
                    quantity: cityTotalQuantity,
                    cityQuantityForKG: cityTotalQuantityForKG,
                    cityTotalAmountForKG: cityTotalAmountForKG,
                    subCategory: "",
                    siteIndex,
                    matIndex: 0,
                    cityId: city.city_id,
                    siteId: site.site_id,
                  },
                ],
                totalAmount: (
                  <Input
                    disabled
                    value={`\u20B9 ${cityTotalQuantity || 0}`}
                    className="subtotal"
                    readOnly
                  />
                ),
                cityTotalQuantity: (
                  <Input
                    disabled
                    value={cityTotalQuantity || 0}
                    className="city-total-quantity"
                    readOnly
                  />
                ),
              });
            }
          }
        });

        city.city_total_quantity = cityTotal;
      });
      let totalAmount;
      let totalQuantity = 0;
      tableData.push({
        key: `Total`,
        siteName: `Estimated PR Amount`,
        siteName1: "Total",
        siteLocations: [
          {
            materialName: "",
            cityTotal: "",
            quantity: "",
            totalCityOverallSite: totalCityOfAllSite,
            cityQuantityForKG: "",
            cityTotalAmountForKG: "",
            subCategory: "",
            siteIndex: 0,
            matIndex: 0,
          },
        ],
        totalAmount: (
          <Input disabled value="₹ 0" className="subtotal" readOnly />
        ),
        totalQuantity: (
          <Input disabled value="0" className="city-total-quantity" readOnly />
        ),
      });
      setTableData(tableData);
      setapiLoading(false);
    };

    updateWbsData = (state) => {
      const tableData = [];
      const length = state?.city_wise_pr?.length;
      setCityLength(length);

      let overallTotal = 0;
      let overallQuantity = 0;
      let overAllSiteTotalAmountForKG = 0;

      state?.city_wise_pr?.forEach((city, cityIndex) => {
        let cityTotalQuantity = 0;
        let cityTotal = 0;
        let cityTotalAmountForKg = 0;

        city.site_wise_details.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteMaterialTotal = 0;
          let siteTotalQuantityForKG = 0;
          let siteTotalAmountForKG = 0;

          site.material_wise_details?.forEach((material) => {
            console.log('qqmaterial', material);
            
            siteTotalQuantity += material.material_type_quantity;
            siteMaterialTotal +=
              material.material_type_quantity *
              material.estimated_material_unit_price;
            let quantityInKG = 0;
            if (material.material_type_name.includes("Sand") && material.material_type_uom_name === "Cum.") {
              siteTotalQuantityForKG +=
                material.material_type_quantity * material.sand_conversion * 1000 || 0;
              quantityInKG = material.material_type_quantity * material.sand_conversion * 1000 || 0;
            }

            else if (material.material_type_name.includes("Aggregate") && material.material_type_uom_name === "Cum.") {
              siteTotalQuantityForKG +=
                material.material_type_quantity * material.aggregate_conversion * 1000 || 0;
              quantityInKG = material.material_type_quantity * material.aggregate_conversion * 1000 || 0;
            } else if (material.material_type_name.includes("Dust") && material.material_type_uom_name === "Cum.") {
              siteTotalQuantityForKG +=
                material.material_type_quantity * material.aggregate_conversion * 1000 || 0;
              quantityInKG = material.material_type_quantity * material.aggregate_conversion * 1000 || 0;
            }
            else if (material.material_type_uom_name === "MT") {
              siteTotalQuantityForKG +=
                material.material_type_quantity * 1000 || 0;
              quantityInKG = material.material_type_quantity * 1000 || 0;
            } 
            else if (material.material_type_uom_name === "Bag") {
              siteTotalQuantityForKG +=
                material.material_type_quantity * 50 || 0;
              quantityInKG = material.material_type_quantity * 50 || 0;
            } else {
              siteTotalQuantityForKG += material.material_type_quantity || 0;
              quantityInKG = material.material_type_quantity || 0;
            }
            // Calculate amount for this material based on quantityInKG
            const amountForMaterial =
              quantityInKG * material.estimated_material_unit_price;
            siteTotalAmountForKG += amountForMaterial;
          });
          cityTotalQuantity += siteTotalQuantity;
          cityTotal += siteMaterialTotal;
          cityTotalAmountForKg += siteTotalAmountForKG;

          tableData.push({
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : null,
            key: `${cityIndex}-${siteIndex}`,
            siteName: site.site_name,
            siteLocations: site.material_wise_details?.map(
              (material, matIndex) => ({
                availableBudget: material.available_budget || 0,
                estimatedPRValue: siteMaterialTotal || 0,
                cityId: city.city_id,
                siteId: site.site_id,
                matIndex,
              })
            ),
          });
        });
        if (length > 1) {
          tableData.push({
            key: `${cityIndex}-CityTotal`,
            siteName: "City Total",
            siteLocations: [
              {
                cityTotal: cityTotal,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${cityTotal || 0}`}
                className="subtotal"
                readOnly
              />
            ),
          });
        }

        overallTotal += cityTotal;
        overallQuantity += cityTotalQuantity;
        overAllSiteTotalAmountForKG += cityTotalAmountForKg;
      });
      const formattedOverallTotal = parseFloat(
        overAllSiteTotalAmountForKG.toFixed(0)
      );
      setOverallTotal(formattedOverallTotal);
      tableData.push({
        key: "OverallTotal",
        siteName: "Total",
        siteLocations: [
          {
            cityTotal: overallTotal,
          },
        ],
        totalAmount: (
          <Input
            disabled
            value={`\u20B9 ${overallTotal || 0}`}
            className="citysubtotal"
            readOnly
          />
        ),
      });

      setStateWBS(tableData);
    };
  } else {
    updateTableData = (state) => {
      setapiLoading(true);
      const tableData = [];
      const length = state?.city_wise_pr?.length;

      setCityLength(length);

      state?.city_wise_pr?.forEach((city, cityIndex) => {
        const cityRowSpan = city.site_wise_pr.length;
        let cityTotalQuantity = 0;
        let cityTotal = 0;

        city.site_wise_pr.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteMaterialTotal = 0;
          site.site_total_quantity += siteTotalQuantity;

          site.pr_material_details?.forEach((material) => {
            siteTotalQuantity += material.pr_material_type_quantity;
            siteMaterialTotal += material.pr_material_type_quantity * 105;
          });
          site.site_total_quantity = siteTotalQuantity;

          setSiteTotalQuantities((prevQuantities) => [
            ...prevQuantities,
            siteTotalQuantity,
          ]);

          cityTotalQuantity += siteTotalQuantity;
          cityTotal += siteMaterialTotal;
          tableData.push({
            key: `${cityIndex}-${siteIndex}`,
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : null,
            cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
            siteName: site.pr_site_name,
            siteLocations: site.pr_material_details?.map(
              (material, matIndex) => ({
                availableBudget: material.available_budget || 0,
                estimatedPRValue: 185 || 0,
                materialName: material.pr_material_type_name,
                remark: material.material_remark,
                quantity: material.pr_material_type_quantity,
                uom: material.pr_material_type_uom,
                subCategory: material.pr_material_type_sub_category,
                siteIndex,
                matIndex,
                cityId: city.city_name,
                siteId: site.pr_site_id,
                estimatedPrice: material.estimated_material_unit_price,
              })
            ),
            totalAmount: <Input disabled className="site-subtotal" />,
          });
          tableData.push({
            key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
            siteName: "Site Sub Total",
            siteLocations: [
              {
                totalQuantity: siteMaterialTotal,
                materialName: "",
                quantity: siteTotalQuantity,
                subCategory: "",
                siteIndex,
                matIndex: 0,
                cityId: city.city_id,
                siteId: site.site_id,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${siteTotalQuantity || 0}`}
                className="site-subtotal"
              />
            ),
            siteTotalQuantity: (
              <Input
                disabled
                value={siteTotalQuantity || 0}
                className="site-total-quantity"
                readOnly
              />
            ),
          });
          if (length > 1) {
            if (siteIndex === city.site_wise_pr.length - 1) {
              tableData.push({
                key: `${cityIndex}-${siteIndex}-CityTotal`,
                siteName: "City Total",
                siteLocations: [
                  {
                    materialName: "",
                    cityTotal: cityTotal,
                    quantity: cityTotalQuantity,
                    subCategory: "",
                    siteIndex,
                    matIndex: 0,
                    cityId: city.city_id,
                    siteId: site.site_id,
                  },
                ],
                totalAmount: (
                  <Input
                    disabled
                    value={`\u20B9 ${cityTotalQuantity || 0}`}
                    className="subtotal"
                    readOnly
                  />
                ),
                cityTotalQuantity: (
                  <Input
                    disabled
                    value={city.city_total_quantity || 0}
                    className="city-total-quantity"
                    readOnly
                  />
                ),
              });
            }
          }
        });

        city.city_total_quantity = cityTotal;
      });
      setTableData(tableData);
      setapiLoading(false);
    };

    updateWbsData = (state) => {
      const tableData = [];
      const length = state?.city_wise_pr?.length;
      setCityLength(length);

      let overallTotal = 0;
      let overallQuantity = 0;

      state?.city_wise_pr?.forEach((city, cityIndex) => {
        let cityTotalQuantity = 0;
        let cityTotal = 0;

        city.site_wise_pr.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteMaterialTotal = 0;

          site.pr_material_details?.forEach((material) => {
            siteTotalQuantity += material.pr_material_type_quantity;
            siteMaterialTotal +=
              material.pr_material_type_quantity *
              material.estimated_material_unit_price;
          });

          cityTotalQuantity += siteTotalQuantity;
          cityTotal += siteMaterialTotal;

          tableData.push({
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : null,
            key: `${cityIndex}-${siteIndex}`,
            siteName: site.pr_site_name,
            siteLocations: site.pr_material_details?.map(
              (material, matIndex) => ({
                availableBudget: material.available_budget || 0,
                estimatedPRValue: siteMaterialTotal || 0,
                cityId: city.city_id,
                siteId: site.site_id,
                matIndex,
              })
            ),
          });
        });
        if (length > 1) {
          tableData.push({
            key: `${cityIndex}-CityTotal`,
            siteName: "City Total",
            siteLocations: [
              {
                cityTotal: cityTotal,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${cityTotal || 0}`}
                className="subtotal"
                readOnly
              />
            ),
          });
        }

        overallTotal += cityTotal;
        overallQuantity += cityTotalQuantity;
      });

      setOverallTotal(overallTotal);

      tableData.push({
        key: "OverallTotal",
        siteName: "Total",
        siteLocations: [
          {
            cityTotal: overallTotal,
          },
        ],
        totalAmount: (
          <Input
            disabled
            value={`\u20B9 ${overallTotal || 0}`}
            className="citysubtotal"
            readOnly
          />
        ),
      });

      setStateWBS(tableData);
    };
  }

  useEffect(() => {
    setapiLoading(true);
    updateTableData(state);
    updateWbsData(state);
    setapiLoading(false);
  }, [state]);

  const handleOk = () => {
    setSiteModal(false);
  };
  const handleSave = (data) => {
    setSiteName(data);
    setUserSelectedSiteList(data);
    setSiteModal(false);
  };
  const handleCancel = () => {
    setSiteModal(false);
  };
  const getUnitOfMeasurement = async () => {
    setapiLoading(true);
    try {
      const fields = [
        "id",
        "unit_of_measurement",
        "category_tree_name",
        "category_tree",
      ].join(",");
      const queryParams = new URLSearchParams();
      queryParams.set("category_tree", categoryId);
      queryParams.set("fields", fields);

      const response = await getRequest(
        `get-category-by-uom/?${queryParams.toString()}`
      );

      if (response?.data?.results?.data) {
        const filteredData = response.data.results.data.filter(
          (item) => item.unit_of_measurement !== "KG"
        );
        setPincodeList(filteredData);
      } else {
        ErrorNotificationMsg(t("error_in_unit_of_measurement"));
        setPincodeList([]);
      }
    } catch (error) {
      console.error(
        "Error fetching unit of measurement:",
        error.response?.data || error.message
      );
      ErrorNotificationMsg(
        t("error_in_unit_of_measurement") +
          ": " +
          (error.message || "Unknown error")
      );
      setPincodeList([]);
    }
    setapiLoading(false);
  };

  const getSiteName = async () => {
    try {
      const fields = ["id", "site_name", "city_name"].join(",");
      const queryParams = new URLSearchParams();
      queryParams.set("category_tree", categoryId);
      queryParams.set("fields", fields);

      let apiResponse = await getRequest(
        `delivery-address/${CompanyID}/address-by-company/?${queryParams.toString()}`
      );
      if (apiResponse.data.data) {
        setSiteName(apiResponse.data.data);
        if (siteIds && siteIds.length > 0) {
          const selectedSites = apiResponse.data.data
            .filter((site) => siteIds.includes(site.id))
            .map((site) => ({
              id: site.id,
              site_name: site.site_name,
              city_name: site.city_name,
            }));
          setUserSelectedSiteList(selectedSites);
        }
        const updatedState = { ...state };
        updatedState.purchase_requisition_details.forEach((detail) => {
          detail.site_wise.forEach((site, index) => {
            site.site_name = apiResponse.data.data[index]
              ? apiResponse.data.data[index].site.id
              : null;
          });
        });
        setState(updatedState);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
    } catch (error) {
      //setLoading(false);
    }
  };

  const handleRemarkChange = (e, cityId, siteId, matIndex) => {
    const { value } = e.target;
    if (prId) {
      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_name === cityId) {
            city.site_wise_pr = city.site_wise_pr.map((site, siteIndex) => {
              if (site.pr_site_id === siteId) {
                site.pr_material_details[matIndex].material_remark = value || 0;
              }
              return site;
            });
          }
          return city;
        });
        return newState;
      });
    } else {
      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_id === cityId) {
            city.site_wise_details = city.site_wise_details.map(
              (site, siteIndex) => {
                if (site.site_id === siteId) {
                  site.material_wise_details[matIndex].material_remark = value;
                }
                return site;
              }
            );
          }
          return city;
        });
        return newState;
      });
    }
  };
  // const handleInputChange = (e, cityId, siteId, matIndex) => {
  //   let { value } = e.target;
  //   if (value === "") {
  //     value = "";
  //   } else {
  //     value = isNaN(value) ? "" : value;
  //   }

  //   setState((prevState) => {
  //     const newState = { ...prevState };
  //     newState.city_wise_pr = newState.city_wise_pr.map((city) => {
  //       if (city.city_id === cityId) {
  //         city.site_wise_details = city.site_wise_details.map(
  //           (site, siteIndex) => {
  //             if (site.site_id === siteId) {
  //               site.material_wise_details[matIndex].material_type_quantity =
  //                 value || 0;
  //                 console.log("siteeee", site);
  //                 if (
  //                 site.material_wise_details[matIndex]
  //                   .material_type_uom_name === "MT" && site.material_wise_details[matIndex]
  //                   .material_type_sub_category?.includes("Sand")
  //               ) {
  //                 console.log('ddddddddddddd', value);

  //                 site.material_wise_details[
  //                   matIndex
  //                 ].material_total_quantity_by_kg = value * 1.6 || 0;
  //               }
  //               else if (
  //                 site.material_wise_details[matIndex]
  //                   .material_type_uom_name === "MT" && !site.material_wise_details[matIndex]
  //                   .material_type_sub_category?.includes("Sand")
  //               ) {
  //                 site.material_wise_details[
  //                   matIndex
  //                 ].material_total_quantity_by_kg = value * 1000 || 0;
  //               } else if (
  //                 site.material_wise_details[matIndex]
  //                   .material_type_uom_name === "Bag"
  //               ) {
  //                 site.material_wise_details[
  //                   matIndex
  //                 ].material_total_quantity_by_kg = value * 50 || 0;
  //               } else if (
  //                 site.material_wise_details[matIndex]
  //                   .material_type_uom_name === "cubicMeter"
  //               ) {
  //                 site.material_wise_details[
  //                   matIndex
  //                 ].material_total_quantity_by_kg = 0;
  //               } else {
  //                 site.material_wise_details[
  //                   matIndex
  //                 ].material_total_quantity_by_kg = value || 0;
  //               }
  //             }

  //             return site;
  //           }
  //         );
  //       }
  //       return city;
  //     });
  //     return newState;
  //   });

  //   // }
  // };

  const handleInputChange = (e, cityId, siteId, matIndex) => {
    let { value } = e.target;
    if (value === "" || isNaN(value) || value < 0) {
      value = 0;
    } else {
      value = value;
    }

    setState((prevState) => {
      const newState = { ...prevState };
      newState.city_wise_pr = newState.city_wise_pr.map((city) => {
        if (city.city_id === cityId) {
          city.site_wise_details = city.site_wise_details.map(
            (site, siteIndex) => {
              if (site.site_id === siteId) {
                const material = site.material_wise_details[matIndex];
                material.material_type_quantity = value;

                if (material.material_type_name?.includes("Sand")) {
                  console.log('matdddsserial', material);
                  
                  if (material.material_type_uom_name === "MT") {
                    material.material_total_quantity_by_kg =
                      value * 1000 || 0;
                  } 
                  else if (material.material_type_uom_name === "Cum.") {
                    material.material_total_quantity_by_kg =
                      value * material.sand_conversion * 1000 || 0;
                  }                  else if (
                    material.material_type_uom_name === "Cubic Meter"
                  ) {
                    // 1 Cum = 1.6 MT = 1,600 kg
                    material.material_total_quantity_by_kg =
                      value * 1.6 * 1000 || 0;
                  } else if (material.material_type_uom_name === "Bag") {
                    material.material_total_quantity_by_kg = value * 50 || 0;
                  } else {
                    material.material_total_quantity_by_kg = value || 0;
                  }
                }
                
                else if (material.material_type_name?.includes("Aggregate")) {
                  console.log('matdddsserial', material);
                  
                  if (material.material_type_uom_name === "MT") {
                    material.material_total_quantity_by_kg =
                      value * 1000 || 0;
                  } 
                  else if (material.material_type_uom_name === "Cum.") {
                    material.material_total_quantity_by_kg =
                      value * material.aggregate_conversion * 1000 || 0;
                  }                  else if (
                    material.material_type_uom_name === "Cubic Meter"
                  ) {
                    // 1 Cum = 1.6 MT = 1,600 kg
                    material.material_total_quantity_by_kg =
                      value * material.aggregate_conversion * 1000 || 0;
                  } else if (material.material_type_uom_name === "Bag") {
                    material.material_total_quantity_by_kg = value * 50 || 0;
                  } else {
                    material.material_total_quantity_by_kg = value || 0;
                  }
                }
                
                
                else {
                  if (material.material_type_uom_name === "MT") {
                    material.material_total_quantity_by_kg = value * 1000 || 0;
                  } else if (material.material_type_uom_name === "Bag") {
                    material.material_total_quantity_by_kg = value * 50 || 0;
                  } else {
                    material.material_total_quantity_by_kg = value || 0;
                  }
                }
              }
              return site;
            }
          );
        }
        return city;
      });
      return newState;
    });
  };

  console.log("dddstate", state);

  // const handleUOMChange = (
  //   value,
  //   cityId,
  //   siteId,
  //   matIndex,
  //   unitOfMeasurement
  // ) => {
  //   if (prId) {
  //     setState((prevState) => {
  //       const newState = { ...prevState };
  //       newState.city_wise_pr = newState.city_wise_pr.map((city) => {
  //         if (city.city_name === cityId) {
  //           city.site_wise_pr = city.site_wise_pr.map((site, siteIndex) => {
  //             if (site.pr_site_id === siteId) {
  //               site.pr_material_details[matIndex].pr_material_type_uom = value;
  //             }
  //             return site;
  //           });
  //         }
  //         return city;
  //       });
  //       return newState;
  //     });
  //   } else {
  //     setState((prevState) => {
  //       const newState = { ...prevState };
  //       newState.city_wise_pr = newState.city_wise_pr.map((city) => {
  //         if (city.city_id === cityId) {
  //           city.site_wise_details = city.site_wise_details.map(
  //             (site, siteIndex) => {
  //               if (site.site_id === siteId) {
  //                 site.material_wise_details[matIndex].material_type_uom =
  //                   value;
  //                 site.material_wise_details[matIndex].material_type_uom_name =
  //                   unitOfMeasurement;
  //                  if (
  //                 site.material_wise_details[matIndex]
  //                   .material_type_uom_name === "MT" && site.material_wise_details[matIndex]
  //                   .material_type_sub_category?.includes("Sand")
  //               ) {
  //                 console.log('ddddddddddddd', value);

  //                 site.material_wise_details[
  //                   matIndex
  //                 ].material_total_quantity_by_kg = value * 1.6 || 0;
  //               }
  //                   else if (unitOfMeasurement === "MT") {
  //                   site.material_wise_details[
  //                     matIndex
  //                   ].material_total_quantity_by_kg =
  //                     site.material_wise_details[matIndex]
  //                       .material_type_quantity * 1000 || 0;
  //                 } else if (unitOfMeasurement === "Bag") {
  //                   site.material_wise_details[
  //                     matIndex
  //                   ].material_total_quantity_by_kg =
  //                     site.material_wise_details[matIndex]
  //                       .material_type_quantity * 50 || 0;
  //                 } else {
  //                   site.material_wise_details[
  //                     matIndex
  //                   ].material_total_quantity_by_kg =
  //                     site.material_wise_details[matIndex]
  //                       .material_type_quantity || 0;
  //                 }
  //               }
  //               return site;
  //             }
  //           );
  //         }
  //         return city;
  //       });
  //       return newState;
  //     });
  //   }
  // };

  const handleUOMChange = (
    value,
    cityId,
    siteId,
    matIndex,
    unitOfMeasurement
  ) => {
    if (prId) {
      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_name === cityId) {
            city.site_wise_pr = city.site_wise_pr.map((site, siteIndex) => {
              if (site.pr_site_id === siteId) {
                site.pr_material_details[matIndex].pr_material_type_uom = value;
                site.pr_material_details[matIndex].pr_material_type_uom_name =
                  unitOfMeasurement;
              }
              return site;
            });
          }
          return city;
        });
        return newState;
      });
    } else {
      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_id === cityId) {
            city.site_wise_details = city.site_wise_details.map(
              (site, siteIndex) => {
                if (site.site_id === siteId) {
                  const material = site.material_wise_details[matIndex];
                  console.log('matssserial', material);
                  
                  material.material_type_uom = value;
                  material.material_type_uom_name = unitOfMeasurement;

                  if (material.material_type_name?.includes("Sand")) {
                    if (unitOfMeasurement === "Cum.") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * 1.6 * 1000 || 0;
                    } else if (unitOfMeasurement === "MT") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * 1000 || 0;
                    } else if (unitOfMeasurement === "Cubic Meter") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * 1.6 * 1000 || 0;
                    } else if (unitOfMeasurement === "Bag") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * 50 || 0;
                    } else {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity || 0;
                    }
                  }
                  
                  else if (material.material_type_name?.includes("Aggregate")) {
                    console.log("wwunitOfMeasurement", unitOfMeasurement, 'matdderial', material);
                    
                    if (unitOfMeasurement === "Cum.") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * material.aggregate_conversion * 1000 || 0;
                    } else if (unitOfMeasurement === "MT") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * 1000 || 0;
                    } else if (unitOfMeasurement === "Cubic Meter") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * material.aggregate_conversion  * 1000 || 0;
                    } else if (unitOfMeasurement === "Bag") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * 50 || 0;
                    } else {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity || 0;
                    }
                  }
                  else if (material.material_type_name?.includes("Dust")) {
                    console.log("wwunitOfMeasurement", unitOfMeasurement, 'matdderial', material);
                    
                    if (unitOfMeasurement === "Cum.") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * material.aggregate_conversion * 1000 || 0;
                    } else if (unitOfMeasurement === "MT") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * 1000 || 0;
                    } else if (unitOfMeasurement === "Cubic Meter") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * material.aggregate_conversion  * 1000 || 0;
                    } else if (unitOfMeasurement === "Bag") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * 50 || 0;
                    } else {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity || 0;
                    }
                  }
                  else {
                    if (unitOfMeasurement === "MT") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * 1000 || 0;
                    } else if (unitOfMeasurement === "Bag") {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity * 50 || 0;
                    } else {
                      material.material_total_quantity_by_kg =
                        material.material_type_quantity || 0;
                    }
                  }
                }
                return site;
              }
            );
          }
          return city;
        });
        return newState;
      });
    }
  };

  const filterItemsBySubCategory = (subCategory) => {
    return subCategoryData.filter((item) => item.sub_category === subCategory);
  };

  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };

  const wbsBudget = [
    {
      title: "SR.",
      dataIndex: "srNo",
      fixed: "left",
      width: 70,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      fixed: "left",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    },
    {
      title: "Available Budget",
      dataIndex: "siteLocations",
      width: 200,
      render: (siteLocations, record) => {
        if (record.siteName !== "City Total" && record.siteName !== "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div key={1} className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  readOnly
                  value={1000000}
                />
              </div>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: "Estimated PR Value",
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        if (record.siteName === "City Total" || record.siteName === "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "20%" }}
                  value={siteLocations[0].cityTotal}
                  readOnly
                />
              </div>
            </div>
          );
        } else {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div key={1} className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "20%" }}
                  value={siteLocations[0].estimatedPRValue}
                  readOnly
                />
              </div>
            </div>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    wbsBudget.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    });
  }

  const theadWbsBudget = <Table columns={wbsBudget} />;

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 140,
      render: (text, record) => {
        if (record?.key?.includes("SiteSubTotal")) {
          if (record?.siteName1 === "Site Sub Total") {
            return <div className="subtotal">{record.siteName1}</div>;
          }
        } else if (record?.key?.includes("CityTotal")) {
          if (record?.siteName1 === "City Total") {
            return <div className="citytotal">{record.siteName1}</div>;
          }
        } else if (record?.key?.includes("Total")) {
          return (
            <div
              className="totalCityOverallSitee5"
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                letterSpacing: "1px",
                // padding: "8px 0"
              }}
            >
              {record.siteName1}
            </div>
          );
        }
        return <span>{text}</span>;
      },
    },
    {
      title: "Sub category",
      dataIndex: "siteLocations",
      width: 120,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "22px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.subCategory}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "Item",
      dataIndex: "siteLocations",
      width: 180,
      // width: 120,
      className: "stickyleft",
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "22px", }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.materialName}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "siteLocations",
      width: 140,
      render: (siteLocations, record) => {
        if (record.siteName1 === "Site Sub Total") {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginRight: "20px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue"></div>
                ))}
              </div>
            </>
          );
        } else if (record.siteName1 === "City Total") {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginRight: "20px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue"></div>
                ))}
              </div>
            </>
          );
        } else if (record.siteName1 === "Total") {
          return null;
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginRight: "20px",
                }}
              >
                {siteLocations.map((site, index) => {
                  console.log("sifddddte", site);
                  return (
                    <div key={index} className="lblvalue">
                      <Input
                        type="text"
                        inputMode="decimal"
                        min={0}
                        maxLength={10}
                        style={{ width: "100%" }}
                        value={site.quantity || ""}
                        placeholder="Enter Qty."
                        onChange={(e) => {
                          let value = e.target.value;

                          if (site.materialName.includes("Sand")) {
                            value = value
                              .replace(/[^0-9.]/g, "")
                              .replace(/(\..*?)\..*/g, "$1")
                              .replace(/^\./, "0.");
                            console.log("dddvalue", value);
                          } else {
                            value = value.replace(/[^0-9]/g, ""); // only digits
                          }

                          handleInputChange(
                            { ...e, target: { ...e.target, value } },
                            site.cityId,
                            site.siteId,
                            site.matIndex
                          );
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </>
          );
        }
      },
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Preferred Unit of measurement means Your company buys material
              generally in this unit of measurement
            </span>
          }
        >
          Preferred UoM.
        </Tooltip>
      ),

      width: 120,
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        console.log(
          "ddredddcord",
          record,
          "siteLocations",
          siteLocations,
          "pincodddeList",
          pincodeList
        );

        const defaultOption =
          siteLocations[0]?.materialName?.includes === "Sand"
            ? pincodeList.find((option) => option.unit_of_measurement === "MT")
            : pincodeList.find((option) => option.unit_of_measurement === "MT");
        const defaultValue = defaultOption ? defaultOption.id : 1;
        if (
          record.siteName1 === "City Total" ||
          record.siteName1 === "Site Sub Total"
        ) {
          return "";
        }
        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => {
                if (site.subCategory === "RMC") {
                  return (
                    <div key={index}>
                      <Select
                        style={{ width: "100%" }}
                        defaultValue={"Cu. Mtr."}
                        suffixIcon={null}
                        open={false}
                      />
                    </div>
                  );
                } else if (record.siteName1 === "Total") {
                  return null;
                } else {
                  return (
                    <div key={index}>
                      <Select
                        style={{ width: "100%" }}
                        defaultValue={site?.uom}
                        onChange={(value) => {
                          const selectedOption = pincodeList.find(
                            (option) => option.id === value
                          );
                          handleUOMChange(
                            value,
                            site.cityId,
                            site.siteId,
                            site.matIndex,
                            selectedOption.unit_of_measurement
                          );
                        }}
                      >
                        {pincodeList
                          .filter(
                            (i) => i.unit_of_measurement !== "Cubic Meter"
                          )
                          .map((option) => (
                            <Option key={option.id} value={option.id}>
                              {option.unit_of_measurement}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  );
                }
              })}
            </div>
          </>
        );
      },
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title={<span style={{ color: "#fff" }}>Quantity In Kg</span>}
        >
          Qty. In Kg
        </Tooltip>
      ),
      dataIndex: "siteLocations",
      width: 120,
      align: "right",
      render: (siteLocations, record) => {
        console.log("siteLoddcations", siteLocations);

        if (siteLocations[0]?.materialName?.includes("Sand")) {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "22px",
                  alignItems: "flex-end",
                }}
              >
                {siteLocations.map((site, index) => {
                  console.log("siddddte", site);
                  let total = 0;
                  if (
                    site.materialName.includes("Sand") &&
                    site.material_type_uom_name === "Cum."
                  ) {
                    total = site.quantity * site.sand_conversion * 1000 || 0;
                  } else if (
                    site.materialName.includes("Sand") &&
                    site.material_type_uom_name === "MT"
                  ) {
                    total = site.quantity * 1000 || 0;
                  } else if (
                    site.materialName.includes("Aggregate") &&
                    site.material_type_uom_name === "Cum."
                  ) {
                    total = site.quantity * site.aggregate_conversion * 1000 || 0;
                  } else if (
                    site.materialName.includes("Aggregate") &&
                    site.material_type_uom_name === "MT"
                  ) {
                    total = site.quantity * 1000 || 0;
                  } else if (site.material_type_uom_name === "MT") {
                    total = site.quantity * 1000 || 0;
                  } else if (site.material_type_uom_name === "Cum") {
                    total = site.quantity * 1600 || 0;
                  } else {
                    total = site.quantity || 0;
                  }
                  if (site.materialName !== "") {
                    return (
                      <div key={index} className="lblvalue">
                        {site.subCategory === "RMC" && total == 0
                          ? "-"
                          : total.toLocaleString("en-IN", {
                              maximumFractionDigits: 0,
                            })}
                      </div>
                    );
                  } else if (record.siteName1 === "City Total") {
                    return (
                      <div
                        key={index}
                        className="lblvalue"
                        style={{ padding: "5px" }}
                      >
                        {/* {site.cityQuantityForKG.toLocaleString('en-IN', { maximumFractionDigits: 0 })} */}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        key={index}
                        className="lblvalue"
                        style={{ padding: "5px" }}
                      >
                        {/* {site.totalQuantityByKG ? site.totalQuantityByKG.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0} */}
                      </div>
                    );
                  }
                })}
              </div>
            </>
          );
        }
        else if (siteLocations.some(site => site.category?.includes("Aggregate"))) {
          console.log('siteLossscations', siteLocations);
          
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "22px",
                  alignItems: "flex-end",
                }}
              >
                {siteLocations.map((site, index) => {
                  console.log("siddddte", site);
                  let total = 0;
                  if (
                    site.materialName.includes("Sand") &&
                    site.material_type_uom_name === "Cum."
                  ) {
                    total = site.quantity * site.sand_conversion * 1000 || 0;
                  } else if (
                    site.materialName.includes("Sand") &&
                    site.material_type_uom_name === "MT"
                  ) {
                    total = site.quantity * 1000 || 0;
                  } else if (
                    site.category.includes("Aggregate") &&
                    site.material_type_uom_name === "Cum."
                  ) {
                    total = site.quantity * site.aggregate_conversion * 1000 || 0;
                  } else if (
                    site.category.includes("Aggregate") &&
                    site.material_type_uom_name === "MT"
                  ) {
                    total = site.quantity * 1000 || 0;
                  } else if (site.material_type_uom_name === "MT") {
                    total = site.quantity * 1000 || 0;
                  } else if (site.material_type_uom_name === "Cum") {
                    total = site.quantity * 1600 || 0;
                  } else {
                    total = site.quantity || 0;
                  }
                  if (site.materialName !== "") {
                    return (
                      <div key={index} className="lblvalue">
                        {site.subCategory === "RMC" && total == 0
                          ? "-"
                          : total.toLocaleString("en-IN", {
                              maximumFractionDigits: 0,
                            })}
                      </div>
                    );
                  } else if (record.siteName1 === "City Total") {
                    return (
                      <div
                        key={index}
                        className="lblvalue"
                        style={{ padding: "5px" }}
                      >
                        {/* {site.cityQuantityForKG.toLocaleString('en-IN', { maximumFractionDigits: 0 })} */}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        key={index}
                        className="lblvalue"
                        style={{ padding: "5px" }}
                      >
                        {/* {site.totalQuantityByKG ? site.totalQuantityByKG.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0} */}
                      </div>
                    );
                  }
                })}
              </div>
            </>
          );
        }  else if (siteLocations.subCategory !== "RMC") {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "22px",
                  alignItems: "flex-end",
                }}
              >
                {siteLocations.map((site, index) => {
                  let total = 0;
                  if (site.material_type_uom_name === "MT") {
                    total = site.quantity * 1000 || 0;
                  } else if (site.material_type_uom_name === "Bag") {
                    total = site.quantity * 50 || 0;
                  } else if (site.subCategory === "RMC") {
                    total = 0;
                  } else {
                    total = site.quantity || 0;
                  }
                  if (site.materialName !== "") {
                    return (
                      <div key={index} className="lblvalue">
                        {site.subCategory === "RMC" && total == 0
                          ? "-"
                          : total.toLocaleString("en-IN", {
                              maximumFractionDigits: 0,
                            })}
                      </div>
                    );
                  } else if (record.siteName1 === "City Total") {
                    return (
                      <div
                        key={index}
                        className="lblvalue"
                        style={{ padding: "5px" }}
                      >
                        {/* {site.cityQuantityForKG.toLocaleString('en-IN', { maximumFractionDigits: 0 })} */}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        key={index}
                        className="lblvalue"
                        style={{ padding: "5px" }}
                      >
                        {/* {site.totalQuantityByKG ? site.totalQuantityByKG.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0} */}
                      </div>
                    );
                  }
                })}
              </div>
            </>
          );
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "flex-end",
                  marginRight: "12px",
                }}
              >
                {siteLocations.map((site, index) => {
                  let total = 0;
                  if (site.material_type_uom_name === "MT") {
                    total = site.quantity * 1000 || 0;
                  } else if (site.material_type_uom_name === "Bag") {
                    total = site.quantity * 50 || 0;
                  } else if (site.subCategory === "RMC") {
                    total = 0;
                  } else {
                    total = site.quantity || 0;
                  }
                  if (site.materialName !== "") {
                    return (
                      <div
                        key={index}
                        className="lblvalue"
                        // style={{ padding: "5px" }}
                      >
                        {total
                          ? total.toLocaleString("en-IN", {
                              maximumFractionDigits: 0,
                            })
                          : 0}
                      </div>
                    );
                  } else if (record.siteName1 === "City Total") {
                    return (
                      <div
                        key={index}
                        className="lblvalue"
                        style={{ padding: "5px" }}
                      >
                        {/* {site.cityQuantityForKG.toLocaleString('en-IN', { maximumFractionDigits: 0 })} */}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        key={index}
                        className="lblvalue"
                        style={{ padding: "5px" }}
                      >
                        {/* {site.totalQuantityByKG ? site.totalQuantityByKG.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0} */}
                      </div>
                    );
                  }
                })}
              </div>
            </>
          );
        }
      },
    },

    {
      title: (
        <Tooltip
          title="Reference price of estimated unit rate comes from material master data"
          color="#094E8F"
          placement="top"
        >
          <span>Est. Unit rate</span>
        </Tooltip>
      ),
      dataIndex: "siteLocations",
      width: 110,
      align: "right",
      render: (siteLocations, record) => {
        console.log('reddcord', record);
        
        if (record.siteName1 === "Total") {
          return null;
        } else if (
          record.siteName1 !== "Site Sub Total" &&
          record.siteName1 !== "City Total"
        ) {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "22px",
                  alignItems: "flex-end",
                }}
              >
                {siteLocations.map((site, index) => {
                  console.log("sdddite", site);
                  return (
                    <div key={index} className="lblvalue">
                      ₹ {site.estimated_price}{" "}
                      {site.subCategory === "RMC"
                        ? "/ Cu.M."
                        : site?.category?.includes("Sand") || site?.category?.includes("Aggregate")
                        ? `/ MT`
                        : "/ Kg"}
                    </div>
                  );
                })}
              </div>
            </>
          );
        }
      },
    },

    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title={<span style={{ color: "#fff" }}>Estimated Amount</span>}
        >
          Est. Amount
        </Tooltip>
      ),

      dataIndex: "siteLocations",
      width: 170,
      align: "right",
      render: (siteLocations, record) => {
        return (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: "22px",
              }}
            >
              {siteLocations.map((site, index) => {
                console.log("sdddggite", site);
                let total = 0;

                if (
                  site.materialName.includes("Sand") &&
                  site.material_type_uom_name === "MT"
                ) {
                  total = site.quantity * 1000 || 0;
                } else if (
                  site.materialName.includes("Sand") &&
                  site.material_type_uom_name === "Cum."
                ) {
                  total = site.quantity * 1600 || 0;
                } 
                else if (
                  site?.category?.includes("Aggregate") &&
                  site.material_type_uom_name === "MT"
                ) {
                  total = site.quantity * 1000 || 0;
                } else if (
                  site?.category?.includes("Aggregate") &&
                  site.material_type_uom_name === "Cum."
                ) {
                  total = site.quantity * site.aggregate_conversion * 1000 || 0;
                }
                 else if (site.material_type_uom_name === "MT") {
                  {
                    total = site.quantity * 1000 || 0;
                  }
                  {
                    /* total = site.quantity || 0; */
                  }
                } else if (site.material_type_uom_name === "Bag") {
                  {
                    total = site.quantity * 50 || 0;
                  }
                  {
                    /* total = site.quantity || 0; */
                  }
                } else if (site.material_type_uom_name === "cubicMeter") {
                  total = site.quantity || 0;
                } else {
                  total = site.quantity || 0;
                }
                if (site.materialName !== "") {
                  return (
                    <div key={index}>
                      ₹{" "}
                      {total
                        ? (total * (site?.estimatedPrice || 0))?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          )
                        : 0}
                    </div>
                  );
                } else if (record.siteName1 === "City Total") {
                  return (
                    <div key={index} className="citytotal">
                      ₹{" "}
                      {site.cityTotalAmountForKG
                        ? site.cityTotalAmountForKG?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                } else if (record.siteName1 === "Total") {
                  return (
                    <div
                      key={index}
                      className="totalCityOverallSitee5"
                      style={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        letterSpacing: "1px",
                        textAlign: "end",
                        // padding: "8px 0"
                      }}
                    >
                      ₹{" "}
                      {site.totalCityOverallSite
                        ? site.totalCityOverallSite?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={index}
                      className="subtotal"
                      style={{ padding: "10px" }}
                    >
                      ₹{" "}
                      {site.totalAmountByKG
                        ? site.totalAmountByKG?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                }
              })}
            </div>
          </>
        );
      },
    },
    {
      title: "Remarks",
      dataIndex: "siteLocations",
      width: 170,
      render: (siteLocations, record) => {
        if (record.siteName1 === "Total") {
          return null;
        } else if (
          record.siteName1 !== "Site Sub Total" &&
          record.siteName1 !== "City Total"
        ) {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  // marginRight: "20px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue">
                    <Input
                      type="text"
                      style={{ width: "150px" }}
                      value={site.remark}
                      placeholder="Enter Remarks"
                      onChange={(e) =>
                        handleRemarkChange(
                          e,
                          site.cityId,
                          site.siteId,
                          site.matIndex
                        )
                      }
                    />
                  </div>
                ))}
              </div>
            </>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    columns.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 110,
      render: (text, record, index) => {
        if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
          return <div className="lblvalue">{text}</div>;
        } else {
          return <div className="lblvalue" />;
        }
      },
    });
  }

  const theadPR = <Table columns={columns} />;

  const subCategoryTables = subCategoryList.map((subCategory, index) => {
    const subCategoryItems = filterItemsBySubCategory(subCategory);
    const subCategoryColumns = [
      {
        title: index + 1,
        dataIndex: "Sr No",
        key: "1",
        width: 80,
        render: (text, record, ind) => {
          return `${index + 1}.${ind + 1}`;
        },
      },
      {
        title: subCategory,
        dataIndex: "type_name",
        key: "type_name",
      },
      ...(index === 0
        ? siteName.map((site, index) => ({
            title: site.site_name,
            dataIndex: `site_name_${index}`,
            key: `${site.site_name}_${subCategory}_${index}`,
            width: 170,
            render: (text, record) => (
              <Input
                type="number"
                min={0}
                style={{ width: "100%" }}
                value={record[`quantity_${index}`]}
                onChange={(e) => handleInputChange(e, record.id, index)}
              />
            ),
          }))
        : siteName.map((site, index) => ({
            key: `${site.site_name}_${subCategory}_${index}`,
            width: 170,
            render: (text, record) => (
              <Input
                type="number"
                min={0}
                style={{ width: "100%" }}
                value={record[`quantity_${index}`]}
                onChange={(e) => handleInputChange(e, record.id, index)}
              />
            ),
          }))),
      {
        title: index === 0 ? "Total Quantity" : "",
        dataIndex: "total_quantity",
        key: "total_quantity",
        width: 150,
        render: (text, record) => {
          const correspondingRecord = state.purchase_requisition_details.find(
            (item) => item.material_type === record.id
          );

          const totalQuantity = correspondingRecord
            ? correspondingRecord.total_quantity || ""
            : 0;

          return (
            <Input
              type="number"
              min={0}
              disabled
              style={{ width: "100%" }}
              value={totalQuantity}
            />
          );
        },
      },
      {
        title: index === 0 ? "UOM." : "",
        dataIndex: "unit_of_measurement",
        key: "unit_of_measurement",
        width: 150,
        render: (text, record, rowIndex) => {
          const defaultOption = pincodeList.find(
            (option) => option.unit_of_measurement === "MT"
          );
          const defaultValue = defaultOption ? defaultOption.id : 1;
          return (
            <Select
              style={{ width: "100%" }}
              defaultValue={defaultValue}
              onChange={(value) => handleUOMChange(value, record.id)}
            >
              {pincodeList.map((option) => (
                <Option key={option.id} value={option.id}>
                  {option.unit_of_measurement}
                </Option>
              ))}
            </Select>
          );
        },
      },
    ];

    const theadColumns = <Table columns={subCategoryColumns} />;

    return (
      <>
        <Collapse defaultActiveKey={["4"]} className="collapsescrl">
          <Panel header={theadColumns} key="4">
            <Table
              key={subCategory}
              columns={subCategoryColumns}
              dataSource={subCategoryItems}
              pagination={false}
            />
          </Panel>
        </Collapse>
      </>
    );
  });

  const handleSubmit = async () => {
    console.log('qsqtaqte', state);
    
    try {
      setBtnLoading(true);

      let response;

      if (!prId) {
        const payload1 = {
          company: CompanyID,
          category_tree: Number(id),
          total_amount: overallTotal.toFixed(0),
          pr_site_details: state.city_wise_pr.flatMap((city) =>
            city.site_wise_details.map((site) => {
              const materialDetails = site.material_wise_details
                .filter((detail) => Number(detail.material_type_quantity) !== 0)
                .map((detail) => {
                  console.log('deddtail', detail);
                  
                  return {
                    material_type_by_company: detail.material_type_id,
                  total_quantity: Number(detail.material_type_quantity),
                  total_quantity_by_kg:
                    detail.material_type_uom_name === "Cubic Meter"
                      ? 0
                      : detail.material_total_quantity_by_kg,
                  unit_of_measurement: detail.material_type_uom,
                  remark: detail.material_remark,}
                });

              return {
                site_name: site.site_id,
                pr_material_details: materialDetails,
              };
            })
          ),
        };

        response = await postRequest("purchase-requisition/", payload1);
      } else {
        const payload2 = {
          company: CompanyID,
          category_tree: 1,
          total_amount: overallTotal,
          pr_site_details: state.city_wise_pr.flatMap((city) =>
            city.site_wise_pr.map((site) => ({
              site_name: site.pr_site_id,
              pr_material_details: site.pr_material_details.map((detail) => ({
                material_type_by_company: detail.pr_material_type_id,
                total_quantity: detail.pr_material_type_quantity,
                unit_of_measurement: detail.pr_material_type_uom_name,
                remark: detail.material_remark,
              })),
            }))
          ),
        };
        response = await postRequest("purchase-requisition/", payload2);
      }

      if (response.data.success) {
        SuccessNotificationMsg(response.data.message);
        navigate("/purchase-requisition-history");
      } else {
        // Handle unsuccessful response
      }

      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    const { city_wise_pr } = state;

    if (Array.isArray(city_wise_pr)) {
      let shouldEnable = false;

      for (let detail of city_wise_pr) {
        for (let site of detail.site_wise_details) {
          for (let material of site.material_wise_details) {
            if (material.material_type_quantity > 0) {
              shouldEnable = true;
              break;
            }
          }
          if (shouldEnable) break;
        }
        if (shouldEnable) break;
      }

      setDisabled(!shouldEnable);
    }
  }, [state.city_wise_pr]);

  const handleOptionChange = (e) => {
    const value = e.target.value;
    setView(value);
    setViewOption((prevState) => ({
      ...prevState,
      pr_view: value,
    }));
    setState((prevState) => {
      prevState.city_wise_pr.forEach((city) => {
        city.site_wise_details.forEach((site) => {
          site.material_wise_details.forEach((material) => {
            material.material_type_quantity = 0;
          });
          site.site_total_quantity = 0;
          site.site_total_quantity_kg = 0;
          site.site_total_amount_kg = 0;
        });
        city.city_total_quantity = 0;
      });

      return prevState;
    });
    updateTableDataOptionChange(state);
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>
              Purchase Requisition (PR) -{" "}
              {selectedCategoryName === "Cement"
                ? "Cement & RMC"
                : selectedCategoryName}
            </h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/purchase-requisition-history">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/create-pr">{t("Site Selection for PR")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{selectedCategoryName === "Cement"
                ? "Cement & RMC"
                : selectedCategoryName}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Tooltip
            color={"#094E8F"}
            placement="left"
            title={
              <span style={{ color: "#fff" }}>
                The unit rate or price shown in PR is estimated price for
                calculating PR workflows. Citywise actual buying rates can vary.
              </span>
            }
          >
            <Button
              className="SaveGradiantBtn"
              // onClick={handleSubmit}
              // loading={btnLoading}
            >
              {/* Save */}
              <InfoCircleFilled />
            </Button>
          </Tooltip>
        </div>
      </div>
      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body tbl-collapse">
          <Form ref={formRef}>
            <Spin spinning={apiLoading}>
              <Row>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    className="radioitem"
                    name="pr_view"
                    initialValue={view}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    style={{ width: "max-content" }}
                  >
                    <Radio.Group
                      onChange={handleOptionChange}
                      value={view}
                      className="prviewlabel radio"
                    >
                      <Radio value="City Wise">City/Site Wise</Radio>
                      <Radio value="Material Wise">Material wise </Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            </Spin>
          </Form>

          {view === "City Wise" ? (
            <>
              <div className="tablewrp">
                <Collapse defaultActiveKey={["1"]} className="scroll5">
                  <Panel header={theadPR} key="1">
                    <Table
                      columns={columns}
                      dataSource={tableData}
                      pagination={false}
                    />
                  </Panel>
                </Collapse>
              </div>
              <div className="btnwrp" style={{ paddingTop: "16px" }}>
                <ButtonField
                  className="CancelGradiantBtn"
                  type="primary"
                  htmlType="Cancel"
                  label="Cancel"
                  onClick={() => navigate("/purchase-requisition-history")}
                />
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="submit"
                  label="Send PR for Approval"
                  loading={btnLoading}
                  onClick={handleSubmit}
                  disabled={disabled}
                />
              </div>
            </>
          ) : (
            <div className="tablewrp">
              <NewAddPRMaterial
                userSelectedSiteList={{
                  userSelectedSiteList: userSelectedSiteList,
                }}
              />
            </div>
          )}
        </div>
      </section>
    </>
  );
};
export default NewAddPR;
